import * as RadioGroup from "@radix-ui/react-radio-group";
import { styled } from "@vitality-ds/system";
import BaseRadioButtonsContainerStyles from "./styles/BaseRadioButtonsContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseRadioButtonsContainer = styled(RadioGroup.Root, BaseRadioButtonsContainerStyles);